import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';

const BidRateComparison = ({ bidAmount, originZip, destinationZip }) => {
  const [rateData, setRateData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!originZip || !destinationZip || !bidAmount) return;
    if (originZip.length < 3 || destinationZip.length < 3) return;

    setLoading(true);
    ApiClient.get(
      `rates?origin_location_postal_code=${originZip}&destination_location_postal_code=${destinationZip}`
    ).then((res) => {
      if (res?.success && res?.data?.length > 0) {
        setRateData(res.data[0]);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [originZip, destinationZip, bidAmount]);

  if (loading) {
    return (
      <div style={{ padding: '8px 12px', background: '#f8f9fa', borderRadius: 6, fontSize: 13 }}>
        <i className="fa fa-spinner fa-spin"></i> Loading market rate...
      </div>
    );
  }

  if (!rateData || !bidAmount) return null;

  const bid = parseFloat(bidAmount);
  const market = rateData.rate;
  const diff = bid - market;
  const pctDiff = ((diff / market) * 100).toFixed(1);

  // Green = bid below market (good for broker), Red = bid above market
  const isGood = diff <= 0;
  const marginColor = isGood ? '#27ae60' : '#e74c3c';
  const marginBg = isGood ? '#e8f8f0' : '#fdedec';
  const marginLabel = isGood ? 'Below Market' : 'Above Market';

  return (
    <div style={{
      border: `1px solid ${isGood ? '#a9dfbf' : '#f5b7b1'}`,
      borderRadius: 8,
      padding: '12px 16px',
      backgroundColor: marginBg,
      marginBottom: 12
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{
          background: '#3E549D',
          color: '#fff',
          padding: '2px 8px',
          borderRadius: 4,
          fontSize: 11,
          fontWeight: 600
        }}>RATE COMPARISON</span>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 11, color: '#7f8c8d', marginBottom: 2 }}>Carrier's Bid</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#2c3e50' }}>
            ${bid.toLocaleString(undefined, { maximumFractionDigits: 0 })}
          </div>
        </div>

        <div style={{ fontSize: 20, color: '#bdc3c7' }}>vs</div>

        <div>
          <div style={{ fontSize: 11, color: '#7f8c8d', marginBottom: 2 }}>Market Rate (SONAR)</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#3E549D' }}>
            ${market.toLocaleString(undefined, { maximumFractionDigits: 0 })}
          </div>
        </div>

        <div style={{
          background: marginColor,
          color: '#fff',
          padding: '6px 14px',
          borderRadius: 6,
          fontWeight: 700,
          fontSize: 14
        }}>
          {diff > 0 ? '+' : ''}{pctDiff}% {marginLabel}
        </div>
      </div>

      <div style={{ marginTop: 8, fontSize: 12, color: '#7f8c8d' }}>
        Market Range: ${rateData.rate_low} - ${rateData.rate_high} |
        RPM: {rateData.rpm?.toFixed(2)}/mi |
        Confidence: {rateData.confidence_score}/5 |
        Distance: {rateData.length_of_haul} mi
      </div>
    </div>
  );
};

export default BidRateComparison;
